<app-admin-header></app-admin-header>
<app-header></app-header>
<div class="container" *ngIf="userService.hasStudentExperience()">
    <app-student-app></app-student-app>
</div>

<div class="banner" [ngStyle]="{ 'background-image': 'url(\'' + bannerBg + '\')' }">
    <app-browsing-header></app-browsing-header>
    <app-subjects *ngIf="nodeDepth === 1"></app-subjects>
</div>
<div class="p-0 p-md-8 m-md-auto mw-1400">
    <div id="resultsWrapper" class="row browsing-content-wrapper">
        <div *ngIf="nodeDepth > 1" class="col-xs-12 col-sm-12 col-md-3 col-lg-3 topics-wrapper">
            <app-topics></app-topics>
        </div>
        <div
            class="pr-0 pr-lg-1"
            [ngClass]="{
                'col-xs-12 col-sm-12 col-md-9 col-lg-9': nodeDepth > 1,
                'col-xs-12 col-sm-12 col-md-12 col-lg-12': nodeDepth <= 1
            }"
        >
            <app-browsing-results-group
                [resultsPerRow]="resultsPerRow"
            ></app-browsing-results-group>
        </div>
    </div>
</div>
<app-available-features></app-available-features>
<app-footer></app-footer>
<app-simplified-footer></app-simplified-footer>
